import lottieWeb from 'lottie-web';
import $ from "jquery";

const lottie = $('.lottie');

    if (lottie.length) { // progression animations

  const texts = $('.lottie__text');
  let current_percent = 0;
  const howMany = $('.lottie__trackItem').length;
  let lottieHeight = lottie.height();
  let margins = lottieHeight * 0.10;
  let whereStart = lottie.position().top - margins;
  let availableSpace = (lottieHeight - margins) / howMany;

  var animation = lottieWeb.loadAnimation({
    container: document.getElementById('lottie'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: false,
    name: "Animation Desktop",
  });

  var animation1 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-1'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 1",
    initialSegment: [0, 74],
  });

  
  var animation2 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-2'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 2",
    initialSegment: [75, 164],
    });
  
  var animation3 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-3'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 3",
    initialSegment: [165, 239],
  });
  
  texts.eq(0).addClass('animOpacity');

  $(window).scroll(function () {
    let percent = (($(window).scrollTop() - lottie.position().top) / ((availableSpace * (howMany - 1)))) * 100;
    current_percent = percent;
    let calculated = ((availableSpace * (howMany - 1)) / 100 * percent ) +  lottie.position().top;

    if (percent > 100) {
      percent = 100;
    } else if (percent < 0) {
      percent = 0;
    }

    if ($(window).scrollTop() >= whereStart) {

      animation.goToAndStop((Math.round((percent/100) * 239)), true)

      let i = 0;
      for(i; i < howMany; i++) {
        if ($(window).scrollTop() >= whereStart + (availableSpace * i)) {
          $('.lottie__trackItem').removeClass('active');
          $('.lottie__trackItem').eq(i).addClass('active');
          texts.removeClass('animOpacity');
          texts.eq(i).addClass('animOpacity');
        } 
      }

      $('.lottie__trackCurrent').css('width', percent + '%');
    }
  
  });
}

// /** Login section TODO - move to separate file */
// const forgotPasswordLink = $('#wpuf-login-form > a');

// if (forgotPasswordLink.length) {
//   forgotPasswordLink.eq(1).text('Forgot your password?');
// }

const loginForm = $('#wpuf-login-form');

if (loginForm.length) {
  loginForm.append(' |');
}

const success = $('.wpuf-success');

if (success.length) {
  success.each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      $(this).hide();
    });
  });
}

const error = $('.wpuf-error');

if (error.length) {
  error.each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      $(this).hide();
    });
  });
}



$(window).load(function () {


let submitContainer = $('.wpuf-submit');
let loginContainer = $('p.submit');

function ga_this_field_is_required() {
  if (window.location.href.indexOf('/fr/')!=-1) {
    return 'Ce champ est obligatoire';
  } else if (window.location.href.indexOf('/de/') != -1) {
    return 'Dies ist ein Pflichtfeld';
  } else if (window.location.href.indexOf('/en/') != -1) {
    return 'This is a required field';
  } else if (window.location.href.indexOf('/it/') != -1) {
    return 'Questo campo è obbligatorio';
  } else if (window.location.href.indexOf('/es/') != -1) {
    return 'Este campo es obligatorio';
  } else {
    return 'This is a required field';
  }
}
  
function ga_password_didnt_match() {
  if (window.location.href.indexOf('/fr/')!=-1) {
    return 'Le mot de passe ne correspond pas';
  } else if (window.location.href.indexOf('/de/') != -1) {
    return 'Passwort stimmt nicht überein';
  } else if (window.location.href.indexOf('/en/') != -1) {
    return 'Password didn\'t match';
  } else if (window.location.href.indexOf('/it/') != -1) {
    return 'La password non corrisponde';
  } else if (window.location.href.indexOf('/es/') != -1) {
    return 'Password didn\'t match';
  } else {
    return 'Password didn\'t match';
  }
}

function ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state) {
  if (first_name_state && last_name_state && dropdown_state && institution_state && user_email_state && pass1_state && pass2_state && pass_comparsion_state) {
    $('#fakeSubmit').hide();
    $('.wpuf-wordlimit-message').hide();
    $('.ga-errors').removeClass('ga-errors');
  } else {
    $('#fakeSubmit').show();
  }
}
  
function ga_check_form_on_click(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state) {
  if (first_name_state && last_name_state && dropdown_state && institution_state && user_email_state && pass1_state && pass2_state && pass_comparsion_state) {
    $('#fakeSubmit').hide();
    $('.wpuf-wordlimit-message').hide();
    $('.ga-errors').removeClass('ga-errors');
  } else {
    if (!first_name_state) {
      first_name.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!last_name_state) {
      last_name.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!dropdown_state) {
      dropdown.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!institution_state) {
      institution.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!user_email_state) {
      user_email.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!pass1_state) {
      pass1.addClass('ga-errors').parent().next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
      showPasswordRequirements();
    }
    if (!pass2_state) {
      pass2.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!pass_comparsion_state) {
      pass2.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_password_didnt_match());
    }
  }
}
  
function ga_check_login(username_state, password_state) {

  if (username_state && password_state) {
    $('#fakeLogin').hide();
    $('.wpuf-wordlimit-message').hide();
    $('.ga-errors').removeClass('ga-errors');
  } else {
    $('#fakeLogin').show();
  }
}
  
function ga_check_login_on_click(username_state, password_state) { // login form validation on the fakeButton click - which I'm pretty sure is never called
  if ( username_state && password_state ) {
    $('#fakeLogin').hide();
    $('.wpuf-wordlimit-message').hide();
    $('.ga-errors').removeClass('ga-errors');
  } else {
    if (!username_state) {
      username.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
    if (!password_state) {
      password.addClass('ga-errors').next('.wpuf-wordlimit-message').text(ga_this_field_is_required());
    }
  }
}
  
  if (loginForm.length) { //login form

    loginContainer.append($("<div class='fakeFormButton' id='fakeLogin'></div>"));

    if ($('#wpuf-login-form > .wpuf-error').length) {
      $('#wpuf-login-form > .wpuf-error').show();
        if (window.location.href.indexOf('/fr/')!=-1) {
          $('#wpuf-login-form > .wpuf-error').text('Nom d\'utilisateur ou mot de passe invalide');
        } else if (window.location.href.indexOf('/de/') != -1) {
          $('#wpuf-login-form > .wpuf-error').text('Ungültiger Benutzername oder Passwort');
        } else if (window.location.href.indexOf('/en/') != -1) {
          $('#wpuf-login-form > .wpuf-error').text('Invalid username or password');
        } else if (window.location.href.indexOf('/it/') != -1) {
          $('#wpuf-login-form > .wpuf-error').text('Nome utente o password non validi');
        } else if (window.location.href.indexOf('/es/') != -1) {
          $('#wpuf-login-form > .wpuf-error').text('Invalid username or password');
        } else {
          $('#wpuf-login-form > .wpuf-error').text('Invalid username or password');
        }
    } 


    var username = $('#wpuf-user_login');
    var password = $('#wpuf-user_pass');

    var username_state = false;
    var password_state = false;

    username.parent().append('<span class="wpuf-wordlimit-message wpuf-help"></span>');
    password.parent().append('<span class="wpuf-wordlimit-message wpuf-help"></span>');

    $('#fakeLogin').on('click', function () { 
      // this is only ever shown when one of the fields is empty so leaving in for now even if the validation shoukd not be on a fake element
      ga_check_login_on_click(username_state, password_state);
    });

    username.on('input', function () {
      if ($(this).value != '') {
        username_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        username_state = false;
      }
      ga_check_login(username_state, password_state);
    });

    password.on('input', function () {
      if ($(this).value != '') {
        password_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        password_state = false;
      }
      ga_check_login(username_state, password_state);
    });


  }
  
  

  if (submitContainer.length && window.location.href.indexOf('account')===-1) { //registration form
    submitContainer.append($("<div class='fakeFormButton' id='fakeSubmit'></div>"));
    
    //get elements  
    var reg_form = $('.wpuf-form-add');
    var first_name = reg_form.find('input[name=first_name]');
    var last_name = reg_form.find('input[name=last_name]');
    var dropdown = reg_form.find('select[name=dropdown]');
    var institution = reg_form.find('input[name=institution]');
    var user_email = reg_form.find('input[name=user_email]');
    var pass1 = reg_form.find('input[name=pass1]');
    var pass2 = reg_form.find('input[name=pass2]');

    dropdown.parent().append('<span class="wpuf-wordlimit-message wpuf-help"></span>');


    var first_name_state = false;
    var last_name_state = false;
    var dropdown_state = false;
    var institution_state = false;
    var user_email_state = false;
    var pass1_state = false;
    var pass2_state = false;
    var pass_comparsion_state = false;

     
    $('#fakeSubmit').on('click', function () {
      ga_check_form_on_click(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });


    dropdown.on('change', function () {
      if ($(this)[0].value != '-1') {
        dropdown_state = true;
        $(this).removeClass('ga-errors').parent().next('.wpuf-wordlimit-message').hide();
        $(this).addClass('selected');
      } else {
        dropdown_state = false;
        $(this).removeClass('selected');
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    first_name.on('input', function () {
      if ($(this).value != '') {
        first_name_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        first_name_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    last_name.on('input', function () {
      if ($(this).value != '') {
        last_name_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        last_name_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    institution.on('input', function () {
      if ($(this).value != '') {
        institution_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        institution_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    user_email.on('input', function () {
      if ($(this).value != '') {
        user_email_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
      } else {
        user_email_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    pass1.on('input', function () {
      if ($(this).value != '') {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[?!@#\$%\^&\*\_\-])(?=.{8,})");
        var i = 0;

        return $(this).each(function () {

          
          var ok = false;
          $(this).data('pass-req-id', i++);

          $(this).keyup(function () {

            
                    if(strongRegex.test($(this).val())) {
                      pass1_state = true;
                      $(this).removeClass('ga-errors').parent().next('.wpuf-wordlimit-message').hide();
                      $('.wpuf-submit-button').prop('disabled', false);
                    } else {
                      pass1_state = false;
                      $(this).parent().next('.wpuf-wordlimit-message').show();
                      $('.wpuf-submit-button').prop('disabled', true);
                    }
          });

          
          if (window.location.href.indexOf('/fr/')!=-1) {
            $(this).parent().next('.wpuf-wordlimit-message').text("Votre mot de passe doit contenir : un chiffre, une majuscule, une minuscule, un caractère spécial (?!@#%&_-) et être composé d'au moins 8 caractères.");
          } else if (window.location.href.indexOf('/de/') != -1) {
            $(this).parent().next('.wpuf-wordlimit-message').text('Ihr Passwort muss folgendes enthalten: Zahl, Großbuchstabe, Kleinbuchstabe, Sonderzeichen (?!@#%&_-) und mindestens 8 Zeichen lang sein.');
          } else if (window.location.href.indexOf('/en/') != -1) {
            $(this).parent().next('.wpuf-wordlimit-message').text('Your password must contain: Number, Uppercase, Lowercase, Special character (?!@#%&_-) and be at least 8 characters long.');
          } else if (window.location.href.indexOf('/it/') != -1) {
            $(this).parent().next('.wpuf-wordlimit-message').text('La password deve contenere: Numero, Maiuscolo, Minuscolo, Carattere speciale (?!@#%&_-) e deve essere lunga almeno 8 caratteri.');
          } else if (window.location.href.indexOf('/es/') != -1) {
            $(this).parent().next('.wpuf-wordlimit-message').text('Su contraseña debe contener: Número, Mayúsculas, Minúsculas, Carácter especial (?!@#%&_-) y tener al menos 8 caracteres.');
          } else {
            $(this).parent().next('.wpuf-wordlimit-message').text('Your password must contain: Number, Uppercase, Lowercase, Special character (?!@#%&) and be at least 8 characters long.');
          }

          $(this).focus(function () {
              $(this).keyup();
          });
        });
      } else {
        pass1_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });

    pass2.on('input', function () {
      if ($(this).value != '') {
        pass2_state = true;
        $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
        if ($(this).val() == pass1.val()) {
          pass_comparsion_state = true;
          $(this).removeClass('ga-errors').next('.wpuf-wordlimit-message').hide();
        } else {
          pass_comparsion_state = false;
          $(this).addClass('ga-errors').next('.wpuf-wordlimit-message').show().text(ga_password_didnt_match());
        }

        
      } else {
        pass2_state = false;
      }
      ga_check_form(first_name_state, last_name_state, dropdown_state, institution_state, user_email_state, pass1_state, pass2_state, pass_comparsion_state);
    });
  
}

});


const openNext = $('.open-next');

if (openNext.length) {
  openNext.each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();

      $(this).addClass('is-open');
      $(this).prev('.to-be-opened').addClass('is-open');
    });
  });
}

if (typeof $ === 'undefined') {
  throw new Error('PassRequirements requires $')
}


function showPasswordRequirements(){
  var passwordMessage = document.querySelector('.wpuf-el.password .wpuf-wordlimit-message');

  if (passwordMessage){
    if (window.location.href.indexOf('/fr/')!=-1) {
      passwordMessage.innerHTML = "Votre mot de passe doit contenir : un chiffre, une majuscule, une minuscule, un caractère spécial (?!@#%&_-) et être composé d'au moins 8 caractères.";
    } else if (window.location.href.indexOf('/de/') != -1) {
      passwordMessage.innerHTML = 'Ihr Passwort muss folgendes enthalten: Zahl, Großbuchstabe, Kleinbuchstabe, Sonderzeichen (?!@#%&_-) und mindestens 8 Zeichen lang sein.';
    } else if (window.location.href.indexOf('/en/') != -1) {
      passwordMessage.innerHTML = 'Your password must contain: Number, Uppercase, Lowercase, Special character (?!@#%&_-) and be at least 8 characters long.';
    } else if (window.location.href.indexOf('/it/') != -1) {
      passwordMessage.innerHTML = 'La password deve contenere: Numero, Maiuscolo, Minuscolo, Carattere speciale (?!@#%&_-) e deve essere lunga almeno 8 caratteri.';
    } else if (window.location.href.indexOf('/es/') != -1) {
      passwordMessage.innerHTML = 'Su contraseña debe contener: Número, Mayúsculas, Minúsculas, Carácter especial (?!@#%&_-) y tener al menos 8 caracteres.';
    } else {
      passwordMessage.innerHTML = 'Your password must contain: Number, Uppercase, Lowercase, Special character (?!@#%&) and be at least 8 characters long.';
    }
  }
  
}

showPasswordRequirements();


(function ($) {

    $.fn.PassRequirements = function (options) {
        
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[?!@#\$%\^&\*\_\-])(?=.{8,})");

        var i = 0;

        return this.each(function () {
          
          var ok = false;
            $(this).data('pass-req-id', i++);

          $(this).keyup(function () {
            
                    if(strongRegex.test($(this).val())) {
                      ok = true;
                      $(this).parent().next('.wpuf-wordlimit-message').hide();
                      //$('input[type=submit]').show();
                      $('.wpuf-submit-button').prop('disabled', false);
                    } else {
                      ok = false;
                      $(this).parent().next('.wpuf-wordlimit-message').show();
                      $('.wpuf-submit-button').prop('disabled', true);
                      //$('input[type=submit]').hide();
                    }

            });

          $(this).focus(function () {
              $(this).keyup();
          });
        });
    };

}($));



function getUrlValue(varName) {
  var split = $(location).attr('href').split('?');
    var value = '';
    if (split.length == 2) {
        split = split[1].split('&');
        for (var i = 0; i < split.length; i+=1) {
            var keyValue = split[i].split('=');
            if (keyValue.length == 2 && keyValue[0] == varName) {
                value = keyValue[1];
                break;
            }
        }
    }
    return value;
}

  let _get_id = getUrlValue('id');

  if (_get_id !== '') {
    if ($('input[name=user_source]').length) {
      $('input[name=user_source]').val(_get_id);
    }
  }